import { render } from "./Hero.vue?vue&type=template&id=528b9dd4&scoped=true"
const script = {}

import "./Hero.vue?vue&type=style&index=0&id=528b9dd4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-528b9dd4"]])

export default __exports__